import { Controller } from "@hotwired/stimulus"

// Optional fee dropdown: disable online/charge when a fee is selected; default payment amount from fee.
export default class extends Controller {
  static targets = ["feeSelect", "transactionSelect", "amount"]
  static values = { feeAmounts: Object }

  connect() {
    if (!this.hasFeeSelectTarget) return
    this.syncTransactionTypes()
    this.applyAmountFromFee()
  }

  feeChanged() {
    if (!this.hasFeeSelectTarget) return
    this.syncTransactionTypes()
    this.applyAmountFromFee()
  }

  syncTransactionTypes() {
    const hasFee = this.feeSelectTarget.value !== ""
    for (const opt of this.transactionSelectTarget.options) {
      if (opt.value === "online_payment" || opt.value === "charge") {
        opt.disabled = hasFee
      }
    }
    if (
      hasFee &&
      (this.transactionSelectTarget.value === "online_payment" ||
        this.transactionSelectTarget.value === "charge")
    ) {
      this.transactionSelectTarget.value = "cash"
      this.transactionSelectTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  applyAmountFromFee() {
    const guid = this.feeSelectTarget.value
    if (!guid || !this.hasAmountTarget) return
    const amt = this.feeAmountsValue[guid]
    if (amt != null && amt !== "") {
      const parsed = Number(amt)
      this.amountTarget.value = Number.isFinite(parsed) ? parsed.toFixed(2) : amt
    }
  }
}
